import React, { useState } from 'react';
import { TextField, Box } from '@mui/material';
import { useSearch } from '../contexts/SearchContext';

const SearchBar: React.FC = () => {
  const { searchTerm, setSearchTerm } = useSearch();
  const [inputValue, setInputValue] = useState(searchTerm);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(value);

    // Limpiar el timeout previo si está presente
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Crear un nuevo timeout para actualizar el término de búsqueda después de 500ms
    const newTimeout = setTimeout(() => {
      setSearchTerm(value); // Actualiza el término de búsqueda
    }, 500);

    setTypingTimeout(newTimeout); // Guarda el timeout para poder cancelarlo más tarde
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '0px', width: '100%' }}>
      <TextField
        value={inputValue}
        onChange={handleChange}
        placeholder="Buscar productos..."
        variant="outlined"
        size="small"
        fullWidth
        sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
      />
    </Box>
  );
};

export default SearchBar;
